import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { listStaff } from "../../server/apihelper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export const Staff = () => {
  const [staffList, setStaffList] = useState([]);

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const query = "page=1&items_per_page=100&order=asc";
    listStaff(query).then((res) => {
      if (res?.data && Array.isArray(res.data)) {
        const sortedData = [...res.data].sort((a, b) => {
          const aVal = a.order !== undefined && a.order !== null ? Number(a.order) : Number(a.primaryId || a.id || 0);
          const bVal = b.order !== undefined && b.order !== null ? Number(b.order) : Number(b.primaryId || b.id || 0);
          return aVal - bVal;
        });
        setStaffList(sortedData);
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Faculty & Staff at McGAN'S Ooty School of Architecture | Best Architecture Professors in Tamil Nadu
        </title>
        <meta
          name="description"
          content="Explore the faculty and staff at McGAN'S Ooty School of Architecture, featuring top architecture professors in Tamil Nadu. Empowering students with expert guidance and innovative teaching methods."
        />
        <meta
          name="keywords"
          content="Faculty at McGAN'S Ooty, Architecture staff Tamil Nadu, Best architecture professors in India, McGAN'S architecture faculty, Experienced architecture professors, Ooty architecture school faculty"
        />
        <meta property="og:title" content="Faculty & Staff - McGAN'S Ooty School of Architecture" />
        <meta
          property="og:description"
          content="Meet our esteemed faculty and staff at McGAN'S Ooty, shaping future architects in Tamil Nadu."
        />
        <meta property="og:image" content="https://mcgansarch.com/" />
        <link rel="canonical" href="https://mcgansarch.com/staff" />
      </Helmet>

      <h1 style={{ display: "none" }}>
        Architecture Faculty & Staff at McGAN'S Ooty School of Architecture
      </h1>

      {/* Page Banner */}
      <div className="page-banner-area bg-1">
        <div className="container">
          <div className="page-banner-content">
            <h3 className="BannerHeader">Staff</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="navspace">Staff</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Staff Section */}
      <div className="health-care-area pt-100 pb-70">
        <div className="container">
          <div className="row justify-content-left">
            <h2 className="CarrersDetails1">Empowering Our Staff for Success</h2>
            <p>
              We believe that our greatest asset is our people. Our staff is empowered with the tools, training,
              and support they need to thrive. Through continuous learning and growth opportunities, we ensure
              that every team member can excel in their role and contribute to the collective success of our
              organization. Together, we achieve remarkable results and foster a culture of innovation and
              excellence.
            </p>

            {/* Staff Cards */}
            {staffList.map((item, index) => {
              const staffId = item.primaryId || item.id;
              return (
                <div className="col-lg-3 col-md-6 mt-5" key={index}>
                  <div className="single-health-care-card" style={{ width: "261px" }}>
                    <div className="img">
                      <Link to={`/staff-details/${staffId}`}>
                        <img
                          className="staffImage"
                          src={item.profile}
                          style={{
                            width: "261px",
                            height: "300px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          title={item.name || "Faculty at McGAN'S Ooty"}
                          alt={item.name || "Faculty at McGAN'S Ooty"}
                        />
                      </Link>
                    </div>
                    <div className="health-care-content" style={{ width: "261px" }}>
                      <Link to={`/staff-details/${staffId}`}>
                        <h5 className="staffstyle">{item.name}</h5>
                      </Link>
                      <h6 className="staffstyle">{item.designition}</h6>
                    </div>
                  </div>
                </div>
              );
            })}

          </div>
        </div>
      </div>
    </>
  );
};
